import {
  Judge,
  Briefcase,
  Math,
  MessageQuestion,
  Setting,
  // Setting3,
  DocumentText1,
  Data2,
  House2,
  // Camera,
  Moneys,
  ClipboardText,
  TableDocument,
  Notepad2,
  People,
  Bank,
  NotificationStatus,
  LikeDislike,
  Kanban,
  TaskSquare,
  Lovely,
  WalletMoney,
  Graph,
  Building4,
  CardPos,
  Layer,
  MonitorMobbile,
  Chart,
  PercentageSquare,
  UserOctagon,
  UserSearch,
  SearchStatus,
  Personalcard,
  DocumentCopy,
  NoteFavorite,
  Calendar,
  Global,
  Folder2,
  Chart2,
  Profile2User,
  Book1,
  Buildings2,
} from "iconsax-react";
import { PERMISSIONS } from "@/shared/consts";
import { TengeCircleIcon, TengeRecive, TengeSend } from "@/shared/assets/icons";
import {
  HR_CONTRACTS_PAGE_ROUTE,
  HR_EMPLOYEES_PAGE_ROUTE,
  HR_HIRING_PAGE_ROUTE,
  HR_EXPERTS_PAGE_ROUTE,
  LEGAL_TEMPLATES_PAGE_ROUTE,
  LEGAL_APPLICATIONS_PAGE_ROUTE,
  LEGAL_ATTACHED_DOCUMENTS_PAGE_ROUTE,
  HR_LEAVES_PAGE_ROUTE,
  PROJECTS_VOLUNTEERS_PAGE_ROUTE,
  ACCOUNTING_TIMESHEETS_PAGE_ROUTE,
  ACCOUNTING_PURCHASES_PAGE_ROUTE,
  ACCOUNTING_WAREHOUSE_PAGE_ROUTE,
  ACCOUNTING_FIXED_ASSETS_PAGE_ROUTE,
  ACCOUNTING_REPORTS_PAGE_ROUTE,
  ACCOUNTING_FINANCIAL_REPORTS_PAGE_ROUTE,
  ACCOUNTING_TAX_ROUTE,
  ACCOUNTING_INCOME_PAGE_ROUTE,
  ACCOUNTING_CONTRACTOR_PAYROLL_PAGE_ROUTE,
  REQUESTS_PAGE_ROUTE,
  CALCULATIONS_PAGE_ROUTE,
  PENDING_ACTIONS_PAGE_ROUTE,
  PROJECTS_PAGE_ROUTE,
  PROJECT_MONITORING_ROUTE,
  PROJECT_REPORTS_ROUTE,
  ANNUAL_REPORTS_ROUTE,
  ESG_REPORTS_ROUTE,
  SROI_ROUTE,
  BOARD_PAGE_ROUTE,
  FORMS_PAGE_ROUTE,
  BANKING_PAGE_ROUTE,
  HOME_PAGE_ROUTE,
  // CHAT_ADMIN_PAGE_ROUTE,
  // FSM_MY_REPORTS_PAGE_ROUTE,
  ACCOUNTING_PROJECT_TABLE_PAGE_ROUTE,
  FINANCE_PAGE_ROUTE,
  ACCOUNTING_ADVANCES_PAGE_ROUTE,
  SUPPORT_PAGE_ROUTE,
  COMMUNITY_PAGE_ROUTE,
  REGISTRY_PROJECTS_PAGE_ROUTE,
  REGISTRY_ORGANIZATIONS_PAGE_ROUTE,
} from "@/shared/utils";
import { runtimeConfig, isInternalAccountingEnabled } from "@/shared/config/runtime";
import type { SidebarItem, SidebarSection } from "./types";

function withIcon(Component: React.ElementType) {
  return Component;
}

export const sidebarConfig: SidebarSection[] = [
  {
    label: "keepInformed",
    items: [
      {
        type: "link",
        label: "home",
        icon: withIcon(House2),
        href: HOME_PAGE_ROUTE,
      },
      {
        type: "link",
        label: "self.requests",
        icon: withIcon(NotificationStatus),
        href: REQUESTS_PAGE_ROUTE,
        requiredPermissions: [PERMISSIONS.SELF.APPLY_LEAVE],
      },
      {
        type: "link",
        label: "pendingActions",
        icon: withIcon(LikeDislike),
        href: PENDING_ACTIONS_PAGE_ROUTE,
      },
      {
        type: "link",
        label: "community",
        icon: withIcon(Profile2User),
        href: COMMUNITY_PAGE_ROUTE,
        requiredFeature: "community",
      },
      {
        type: "link",
        label: "myCalculations",
        icon: withIcon(DocumentText1),
        href: CALCULATIONS_PAGE_ROUTE,
        requiredRoles: ["contractor", "msb_contractor"],
      },
      // {
      //   type: "link",
      //   label: "myFsmReports",
      //   icon: withIcon(Camera),
      //   href: FSM_MY_REPORTS_PAGE_ROUTE,
      //   excludeUserTypes: ["msb_contractor"],
      // },
      // {
      //   type: "link",
      //   label: "chatAdmin",
      //   icon: withIcon(Setting3),
      //   href: CHAT_ADMIN_PAGE_ROUTE,
      //   requiredPermissions: [PERMISSIONS.CHAT.MANAGE_CHANNELS],
      //   enabled: runtimeConfig.enableChatAdmin,
      // },
    ],
  },
  {
    label: "operations",
    items: [
      {
        type: "dropdown",
        label: "projects",
        icon: withIcon(Briefcase),
        requiredPermissions: [
          PERMISSIONS.PROJECTS.VIEW_BOARD,
          PERMISSIONS.PROJECTS.VIEW_VOLUNTEERS,
          PERMISSIONS.FORMS.MANAGE,
          PERMISSIONS.PROJECTS.MANAGE_TASKS,
        ],
        children: [
          {
            type: "link",
            label: "projects.list",
            icon: withIcon(Data2),
            href: PROJECTS_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_BOARD],
          },
          {
            type: "link",
            label: "projects.taskBoard",
            icon: withIcon(Kanban),
            href: BOARD_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_BOARD],
          },
          {
            type: "link",
            label: "projects.forms",
            icon: withIcon(TaskSquare),
            href: FORMS_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.FORMS.MANAGE, PERMISSIONS.PROJECTS.MANAGE_TASKS],
            excludeUserTypes: ["contractor", "msb_contractor", "volunteer"],
          },
          {
            type: "link",
            label: "projects.volunteers",
            icon: withIcon(Lovely),
            href: PROJECTS_VOLUNTEERS_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_VOLUNTEERS],
          },
          {
            type: "link",
            label: "projects.projectTable",
            icon: withIcon(TableDocument),
            href: ACCOUNTING_PROJECT_TABLE_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_PROJECT_TABLE],
            enabled: isInternalAccountingEnabled,
          },
        ],
      },
      {
        type: "dropdown",
        label: "registries",
        icon: withIcon(Book1),
        requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_BOARD],
        children: [
          {
            type: "link",
            label: "registries.projects",
            icon: withIcon(Data2),
            href: REGISTRY_PROJECTS_PAGE_ROUTE,
            requiredFeature: "registry",
            requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_BOARD],
          },
          {
            type: "link",
            label: "registries.organizations",
            icon: withIcon(Buildings2),
            href: REGISTRY_ORGANIZATIONS_PAGE_ROUTE,
            requiredFeature: "registry",
            requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_BOARD],
          },
        ],
      },
      {
        type: "dropdown",
        label: "finance",
        icon: withIcon(TengeCircleIcon),
        children: [
          {
            type: "link",
            label: "finance.budget",
            icon: withIcon(WalletMoney),
            href: FINANCE_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_BUDGET],
            enabled: isInternalAccountingEnabled,
          },
        ],
      },
      {
        type: "dropdown",
        label: "accounting",
        icon: withIcon(Math),
        children: [
          {
            type: "link",
            label: "accounting.income",
            icon: withIcon(TengeRecive),
            href: ACCOUNTING_INCOME_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_INCOME],
            enabled: isInternalAccountingEnabled,
          },
          {
            type: "submenu",
            label: "expenses",
            icon: withIcon(TengeSend),
            children: [
              {
                type: "link",
                label: "accounting.timesheets",
                icon: withIcon(Moneys),
                href: ACCOUNTING_TIMESHEETS_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.HR.VIEW_TIMESHEETS],
              },
              {
                type: "link",
                label: "accounting.contractorPayroll",
                icon: withIcon(CardPos),
                href: ACCOUNTING_CONTRACTOR_PAYROLL_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_GPH],
                enabled: isInternalAccountingEnabled,
              },
              {
                type: "link",
                label: "accounting.purchases",
                icon: withIcon(Layer),
                href: ACCOUNTING_PURCHASES_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.WAREHOUSE.VIEW_INVOICES],
                enabled: isInternalAccountingEnabled,
              },
              {
                type: "link",
                label: "accounting.advances",
                icon: withIcon(Moneys),
                href: ACCOUNTING_ADVANCES_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_ADVANCES],
                enabled: isInternalAccountingEnabled,
              },
            ],
          },
          {
            type: "link",
            label: "finance.banking",
            icon: withIcon(Bank),
            href: BANKING_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.BANKING.VIEW_ACCOUNTS],
            enabled: runtimeConfig.enableBanking,
          },
          {
            type: "submenu",
            label: "assets",
            icon: withIcon(Building4),
            children: [
              {
                type: "link",
                label: "accounting.warehouse",
                icon: withIcon(House2),
                href: ACCOUNTING_WAREHOUSE_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.WAREHOUSE.VIEW_INVENTORY],
                enabled: isInternalAccountingEnabled,
              },
              {
                type: "link",
                label: "accounting.fixedAssets",
                icon: withIcon(MonitorMobbile),
                href: ACCOUNTING_FIXED_ASSETS_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.WAREHOUSE.VIEW_INVENTORY],
                enabled: isInternalAccountingEnabled,
              },
            ],
          },
          {
            type: "submenu",
            label: "reports",
            icon: withIcon(ClipboardText),
            children: [
              {
                type: "link",
                label: "accounting.reports",
                icon: withIcon(Chart),
                href: ACCOUNTING_REPORTS_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_REPORTS],
              },
              {
                type: "link",
                label: "accounting.tax",
                icon: withIcon(PercentageSquare),
                href: ACCOUNTING_TAX_ROUTE,
                requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_TAX_REPORTS],
                enabled: isInternalAccountingEnabled,
              },
              {
                type: "link",
                label: "finance.financialReports",
                icon: withIcon(Graph),
                href: ACCOUNTING_FINANCIAL_REPORTS_PAGE_ROUTE,
                requiredPermissions: [PERMISSIONS.ACCOUNTING.VIEW_REPORTS],
              },
            ],
          },
        ],
      },
      {
        type: "dropdown",
        label: "hr",
        icon: withIcon(People),
        requiredPermissions: [PERMISSIONS.HR.VIEW_EMPLOYEES, PERMISSIONS.HR.VIEW_CONTRACTS],
        children: [
          {
            type: "link",
            label: "hr.employees",
            icon: withIcon(UserOctagon),
            href: HR_EMPLOYEES_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.HR.VIEW_EMPLOYEES],
          },
          {
            type: "link",
            label: "hr.experts",
            icon: withIcon(UserSearch),
            href: HR_EXPERTS_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.HR.CREATE_EMPLOYEE],
            requiredFeature: "experts",
            excludeUserTypes: ["expert"],
          },
          {
            type: "link",
            label: "hr.vacations",
            icon: withIcon(SearchStatus),
            href: HR_LEAVES_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.HR.VIEW_LEAVE],
          },
          {
            type: "link",
            label: "hr.hiring",
            icon: withIcon(Personalcard),
            href: HR_HIRING_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.HR.CREATE_EMPLOYEE],
          },
          {
            type: "link",
            label: "hr.contracts",
            icon: withIcon(DocumentCopy),
            href: HR_CONTRACTS_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.HR.VIEW_CONTRACTS],
          },
        ],
      },
      {
        type: "dropdown",
        label: "legal.help",
        icon: withIcon(Judge),
        requiredPermissions: [PERMISSIONS.LEGAL.VIEW_AGREEMENTS],
        children: [
          {
            type: "link",
            label: "legal.templates",
            icon: withIcon(NoteFavorite),
            href: LEGAL_TEMPLATES_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.LEGAL.CREATE_AGREEMENT],
          },
          {
            type: "link",
            label: "legal.applications",
            icon: withIcon(Notepad2),
            href: LEGAL_APPLICATIONS_PAGE_ROUTE,
            requiredPermissions: [PERMISSIONS.LEGAL.VIEW_AGREEMENTS],
          },
        ],
      },
      {
        type: "link",
        label: "legal.attachedDocuments",
        icon: withIcon(Folder2),
        href: LEGAL_ATTACHED_DOCUMENTS_PAGE_ROUTE,
        requiredPermissions: [PERMISSIONS.LEGAL.MANAGE_DOCUMENTS],
      },
    ],
  },
];


// Мониторинг и отчетность рендерятся сразу под селектором проекта: обе страницы
// читают выбранный проект из того же financeScope, что и селектор, поэтому
// живут рядом с ним, а не внутри раздела «Проекты».
export const projectScopeSidebarItems: SidebarItem[] = [
  {
    type: "link",
    label: "projects.monitoring",
    icon: withIcon(Chart),
    href: PROJECT_MONITORING_ROUTE,
    requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_MONITORING],
  },
  {
    type: "dropdown",
    label: "reporting",
    icon: withIcon(NoteFavorite),
    requiredPermissions: [
      PERMISSIONS.PROJECTS.VIEW_REPORTS,
      PERMISSIONS.PROJECTS.VIEW_ANNUAL_REPORTS,
      PERMISSIONS.SUSTAINABILITY.VIEW_REPORTS,
      PERMISSIONS.SROI.VIEW_ASSESSMENTS,
    ],
    children: [
      {
        type: "link",
        label: "reporting.projects",
        icon: withIcon(DocumentText1),
        href: PROJECT_REPORTS_ROUTE,
        requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_REPORTS],
      },
      {
        type: "link",
        label: "reporting.annual",
        icon: withIcon(Calendar),
        href: ANNUAL_REPORTS_ROUTE,
        requiredPermissions: [PERMISSIONS.PROJECTS.VIEW_ANNUAL_REPORTS],
      },
      {
        type: "link",
        label: "reporting.esg",
        icon: withIcon(Global),
        href: ESG_REPORTS_ROUTE,
        requiredPermissions: [PERMISSIONS.SUSTAINABILITY.VIEW_REPORTS],
      },
      {
        type: "link",
        label: "reporting.sroi",
        icon: withIcon(Chart2),
        href: SROI_ROUTE,
        requiredPermissions: [PERMISSIONS.SROI.VIEW_ASSESSMENTS],
      },
    ],
  },
];

export const settingsSidebarSection: SidebarSection = {
  label: "support",
  items: [
    {
      type: "link",
      label: "settings",
      icon: withIcon(Setting),
      href: "/settings",
      enabled: false,
    },
    {
      type: "link",
      label: "supportCenter",
      icon: withIcon(MessageQuestion),
      href: SUPPORT_PAGE_ROUTE,
      carryFrom: true,
    },
  ],
};

